import { IGameState } from "State/Game/IGameState";
import Element from "../Element";
import TextComponent from "Component/Render/Text";
import { getCurrentTractorPosition } from "System/UI/SeasonPass/TractorHelper";
import { SeasonPassRankMilestone } from "Layouts/Quests/SeasonPass/SeasonPassRankMilestone";
import Armature from "Prototype/Armature";
import GameObject from "GameObject/GameObject";
import { Point } from "pixi.js";
import { StartAnimationClip } from "System/Animation/AnimationHelper";
import { DragonbonesDefault } from "System/Animation/Clip";
import { PlaySound } from "System/Audio/AudioHelper";

type SeasonPassRankMilestoneItemProps = {
    state: IGameState;
    key: number;
    itemWidth: number;
};

export class SeasonPassRankMilestoneItem extends Element {
    private state: IGameState;
    private layout: any;
    private key: number;
    private milestoneArmature: Armature;

    public create(props: SeasonPassRankMilestoneItemProps): void {
        const x = props.key * props.itemWidth;

        super.create({
            type: 'group',
            layout: {
                anchors: [0, 0, 0, 0],
                pivot: [0, 0],
                offsets: [-x, 0, -x, 0],
            },
        });

        this.state = props.state;
        this.key = props.key;
        this.layout = new SeasonPassRankMilestone();
        this.addChild(this.layout.root);

        this.milestoneArmature = GameObject.Instantiate(Armature, {
            dragonbonesName: 'filling_progress_bar',
            armatureName: 'milestone',
            alpha: 1,
            playOnStart: false,
            position: new Point(0, 0),
        });
        this.layout.RankMilestone.addChild(this.milestoneArmature);

        this.init();
    }

    public init(animate = false): void {
        this.layout.RankText.getComponent(TextComponent).text = `${this.key + 1}`;

        if (getCurrentTractorPosition(this.state.playerState, true).rank > this.key) {
            StartAnimationClip(
                new DragonbonesDefault(this.milestoneArmature, {
                    animationName: 'activelevel_idle',
                    playTimes: 1,
                    progress: (animate ? 0 : 1),
                })
            );
        } else {
            StartAnimationClip(
                new DragonbonesDefault(this.milestoneArmature, {
                    animationName: 'newlevel_no_ani',
                    playTimes: 1,
                })
            );
        }
    }

    public updateLayout(state: IGameState) {
        this.state = state;
        this.init();
    }

    public animateMilestone() {
        PlaySound('reward-high');
        StartAnimationClip(
            new DragonbonesDefault(this.milestoneArmature, {
                animationName: 'activelevel_idle',
                playTimes: 1,
            })
        );
    }

    public destroy() {
        super.destroy();
    }
}
